import React, { ReactNode, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthContext';
import type { AdminRole } from '../types';
import { hasMinimumRole } from '../permissions';

export function RoleRoute({ minimum, children }: { minimum: AdminRole; children: ReactNode }) {
    const { user, initializing } = useContext(AuthContext);
    if (initializing) return null;
    if (!user) return <Navigate to="/" replace />;
    if (!hasMinimumRole(user.role, minimum)) return <Navigate to="/dashboard" replace />;
    return <>{children}</>;
}
